import { Radio, Typography } from "antd";
import { AnswersPros } from "./survey-answers-content";
import { convertQuillToString } from "../../../../../../../utils/convertQuillToString";

const FileUpload = (props: AnswersPros) => {
const { question } = props;
  return <div className='survey-answers-content__wrapper'>
    <div className='survey-answers-content__title'>
      <Typography.Title level={3}>{convertQuillToString(question.question)}</Typography.Title>
    </div>
    <div className='survey-answers-content__body'>
      {question.resultFile.map((x: any, i: number) => {
        return <div key={i + 1} className='survey-answers-content__body__item'>
          <div className='item__action item__action__file'>
            <a href={x.signedUrl} target="_blank">{x.fileKey.replace('quiz/', '')}</a>
          </div>
        </div>
      })}
    </div>
  </div>
}

export default FileUpload;